import React from 'react';
import { Link } from 'react-router-dom';

const styles = {
	loadAnimation: {
		width: '30%',
		height: '30vh',
		display: 'block',
		margin: 'auto',
	},
};

function UserProfile({ logInStatus, userData }) {
	if (!logInStatus) {
		return (
			<p>
				Please <Link to='/login'>login</Link> to view your profile{' '}
			</p>
		);
	} else if (!userData) {
		return (
			<>
				<iframe
					title='Profile loading animation'
					src='https://lottie.host/embed/65771bbb-4058-42b6-8c2c-6920e436f509/7PzsHwl4nL.json'
					style={styles.loadAnimation}></iframe>
			</>
		);
	} else {
		return (
			<div>
				<h2>Hello {userData.username}</h2>
			</div>
		);
	}
}

export default UserProfile;
